import {
    OreButton,
    OreHeading,
    OreModal,
    OreModalBox,
    OreModalBoxBody,
    OreModalBoxFooter,
    OreStack,
    OreText
} from "@edenredespana/oreneta"
import { Trans, useTranslation } from "react-i18next"
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { navigationRoutes } from "@/Shared/ui/routers"
import { useNavigate } from "react-router-dom"
import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'

interface ReopenTicketCancelModalProps {
    isModalOpen: boolean
    setIsModalOpen: (isOpen: boolean) => void
}

export const ReopenTicketCancelModal = ({ isModalOpen, setIsModalOpen }: ReopenTicketCancelModalProps): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { ticketDetail } = useHelpCenter()

    const handleExitClick = () => {
        setIsModalOpen(false)
        navigate(navigationRoutes.ticketDetail.replace(':ticketId', String(ticketDetail?.caseId)))
    }

    const handleCancelClick = () => {
        setIsModalOpen(false)
    }

    return (
        <OreModal open={isModalOpen} handleOnClose={() => setIsModalOpen(false)}>
            <OreModalBox size="medium" handleOnClose={() => setIsModalOpen(false)}>
                <OreModalBoxBody>
                    <OreHeading size="headline-lg">
                        {t(HelpCenterTranslations.reopenTicket.cancelModal.title)}
                    </OreHeading>
                    <OreText>
                        <Trans t={t}>
                            {t(HelpCenterTranslations.reopenTicket.cancelModal.description)}
                        </Trans>
                    </OreText>
                </OreModalBoxBody>
                <OreModalBoxFooter>
                    <OreStack direction="row" placeItems="center" placeContent="end" space="medium">
                        <OreButton onClick={handleCancelClick} size="small" category="secondary">
                            {t(HelpCenterTranslations.reopenTicket.cancelModal.cancelButton)}
                        </OreButton>
                        <OreButton onClick={handleExitClick} size="small" category="primary">
                            {t(HelpCenterTranslations.reopenTicket.cancelModal.exitButton)}
                        </OreButton>
                    </OreStack>
                </OreModalBoxFooter>
            </OreModalBox>
        </OreModal>
    )
}